import createReduce from './_createReduce.js';

// The right-associative version of reduce, also known as `foldr`.
export default createReduce(-1);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/reduceRight.js
// module id = 1600
// module chunks = 106